import React from "react";
import { useSelector } from "react-redux";

const OptionSixNoJobSidebar = (props: any) => {
    const { navigateToJob, navigateToJobAlerts } = props;
    const questionId = useSelector((state: any) => state?.careers?.getQuestionId);
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const noJobLang = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const noJobLangLabels = noJobLang?.noJobsSection?.[0];

    return (
        <section className="opt6-nojob-sidebar">
            <h3>{noJobLangLabels?.noJobs || "No jobs matching your interest?"}</h3>
            <p dangerouslySetInnerHTML={{ __html: noJobLangLabels?.noJobsText || "Register your interest or set up a job alert and we'll reach out when something matches." }} />
            <div className="opt6-nojob-sidebar-actions">
                {questionId?.status === 200 && (
                    <button className="btn option6-btn option6-btn-muted" onClick={navigateToJob}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                        {cliendConfig?.data?.data?.clientSettings?.registerYourInterestButtonText || noJobLangLabels?.registerYourInterest || "Register Your Interest"}
                    </button>
                )}
                {cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1 && (
                    <button className="btn option6-btn option6-btn-brand" onClick={navigateToJobAlerts}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                        </svg>
                        {cliendConfig?.data?.data?.clientSettings?.jobAlertButtonText || noJobLangLabels?.jobAlerts || "Job Alerts"}
                    </button>
                )}
            </div>
        </section>
    );
};

export default OptionSixNoJobSidebar;
